import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12">
          <div>
            <Link to="/" className="font-heading text-xl text-foreground-900 hover:text-primary-600 transition-colors">
              纲手本子
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              专注火影忍者纲手角色同人创作，汇集高质量纲手本子插画、漫画与同人故事，为资深火影粉丝打造深度内容平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">首页</Link></li>
              <li><Link to="/category/illustration" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">插画作品</Link></li>
              <li><Link to="/category/manga" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">同人漫画</Link></li>
              <li><Link to="/category/story" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">同人故事</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['纲手本子', '百豪之术', '传说三忍', '五代目火影', '木叶村', '同人创作'].map((tag) => (
                <span key={tag} className="px-2.5 py-1 bg-background-200/70 rounded-md text-xs text-foreground-600">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">联系我们</Link></li>
              <li><span className="text-sm text-foreground-600">contact@tsunade-doujin.readdy.ai</span></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between py-6 border-t border-background-200/70">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 纲手本子·高质量同人创作合集。本站为同人创作收录平台，所有内容版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 mt-3 sm:mt-0">
            <a href="#" className="text-foreground-500 hover:text-primary-600 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-600 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-600 transition-colors" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}